"use client"
import { useState, useEffect, useCallback } from "react"

export default function useSimpleModal() {
  const [open, setOpen] = useState(false)

  const openModal = useCallback(() => setOpen(true), [])
  const closeModal = useCallback(() => setOpen(false), [])

  // ESC key closes modal + body scroll lock
  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === "Escape" && closeModal()
    document.addEventListener("keyup", onKey)
    document.body.classList.add("overflow-hidden")

    return () => {
      document.removeEventListener("keyup", onKey)
      document.body.classList.remove("overflow-hidden")
    }
  }, [open, closeModal])

  return { open, openModal, closeModal }
}
